import React from 'react';

import { Link } from '@eika/link';

import { useConfig } from '../../defaultConfig';
import useTranslation from '../../hooks/useTranslation';

export const StepUpLink = () => {
    const translated = useTranslation();
    const { stepUpAuthLink } = useConfig();

    return <Link href={stepUpAuthLink?.url}>{translated.contactInfo.stepUp.link}</Link>;
};
